import React from 'react';
import { Award, Shield, FileCheck, Star } from 'lucide-react';
import { REVIEWS_PLACEHOLDER } from '../../mock';

export const VertrauenSection = () => {
  return (
    <section className="py-28 lg:py-36 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            Vertrauen
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            Wer wir sind
          </h2>
        </div>

        <div className="bg-white border border-gray-200 rounded-3xl p-10 lg:p-12 shadow-lg mb-12">
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="text-center">
              <div className="w-16 h-16 bg-brand-green/10 rounded-2xl flex items-center justify-center mx-auto mb-4 border border-brand-green/15">
                <Award className="w-8 h-8 text-brand-green" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Erfahrung</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Langjährige Expertise in der Unfallschadensbegutachtung
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-brand-green/10 rounded-2xl flex items-center justify-center mx-auto mb-4 border border-brand-green/15">
                <Shield className="w-8 h-8 text-brand-green" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Unabhängigkeit</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Objektive Bewertung ausschließlich im Interesse des Geschädigten
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-brand-green/10 rounded-2xl flex items-center justify-center mx-auto mb-4 border border-brand-green/15">
                <FileCheck className="w-8 h-8 text-brand-green" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Vorgehensweise</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Strukturierte, nachvollziehbare Dokumentation nach anerkannten Standards
              </p>
            </div>
          </div>

          {/* E-E-A-T Block */}
          <div className="border-t border-gray-100 pt-10">
            <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">Unsere Arbeitsweise</h3>
            <p className="text-gray-700 leading-relaxed text-center max-w-3xl mx-auto">
              Unsere Gutachten werden von erfahrenen Sachverständigen erstellt, die regelmäßig Unfallschäden an unterschiedlichen Fahrzeugarten bewerten. Die Begutachtung erfolgt strukturiert, nachvollziehbar und objektiv, mit dem Ziel einer sachlichen und vollständigen Schadenfeststellung.
            </p>
          </div>
        </div>

        {/* Reviews Placeholder */}
        <div>
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">Kundenbewertungen</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {REVIEWS_PLACEHOLDER.map((review) => (
              <div key={review.id} className="bg-white border border-gray-100 rounded-2xl p-6 hover:shadow-xl transition-all duration-300">
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(review.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-brand-green text-brand-green" />
                  ))}
                </div>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">{review.text}</p>
                <div className="pt-4 border-t border-gray-100">
                  <p className="font-semibold text-gray-900 text-sm">{review.name}</p>
                  <p className="text-xs text-gray-500 mt-1">{review.source}</p>
                </div>
              </div>
            ))}
          </div>
          <p className="text-xs text-gray-400 italic text-center mt-6">
            Hinweis: Platzhalter für echte Bewertungen aus Google und ProvenExpert
          </p>
        </div>

        <div className="mt-10 text-center">
          <a href="/bewertungen" className="text-brand-green hover:text-brand-green-dark font-semibold text-lg transition-colors">
            Alle Bewertungen ansehen →
          </a>
        </div>
      </div>
    </section>
  );
};